interface ServiceWorkerRegistrationLike {
  update(): Promise<unknown>;
}

interface ServiceWorkerContainerLike {
  readonly controller: object | null;
  addEventListener(type: 'controllerchange', listener: () => void): void;
  getRegistration(): Promise<ServiceWorkerRegistrationLike | undefined>;
}

interface DocumentLike {
  readonly visibilityState: DocumentVisibilityState;
  addEventListener(type: 'visibilitychange', listener: () => void): void;
}

interface AutomaticServiceWorkerUpdateOptions {
  serviceWorker: ServiceWorkerContainerLike;
  document: DocumentLike;
  reload: () => void;
}

/** Activates a newly deployed app shell and checks again whenever the app returns to view. */
export const installAutomaticServiceWorkerUpdates = ({
  serviceWorker,
  document,
  reload,
}: AutomaticServiceWorkerUpdateOptions): void => {
  let hasController = serviceWorker.controller !== null;
  let reloading = false;

  serviceWorker.addEventListener('controllerchange', () => {
    if (!hasController) {
      hasController = true;
      return;
    }
    if (reloading) return;

    reloading = true;
    reload();
  });

  const checkForUpdate = async (): Promise<void> => {
    try {
      const registration = await serviceWorker.getRegistration();
      await registration?.update();
    } catch {
      // An update check can fail normally while the offline-first app has no network.
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void checkForUpdate();
  });
};
